<template>
    <div style="width: 100%;height: 100%;">
        <div class="search-box">
            <gljy-input v-model:value="searchTitle" :placeholder="searchPlaceholder" clearable prefix-icon="Search" />
            <slot name="search-operate">
            </slot>
        </div>
        <div style="height: calc(100% - 50px);overflow-y: auto;">
            <el-tree :data="options" :props="fieldNames" :expand-on-click-node="false" :filter-node-method="filterNode"
                :node-key="nodeKey" :current-node-key="currentNodeKey" check-on-click-node ref="treeRef" highlight-current
                default-expand-all @node-click="handleNodeClick">
                <template #default="{ node, data }">
                    <slot>
                        <span class="custom-tree-node">
                            <span>{{ i18nConfig(node.label) }}</span>
                            <slot name="titleRight" :node="node" :data="data">
                            </slot>
                        </span>
                    </slot>
                </template>
            </el-tree>
        </div>
    </div>
</template>

<script>
import selectCustomFunction from './select-custom-function';
import { i18nConfig } from '@/utils/ruoyi'
import { ref, reactive, toRefs, onMounted, computed, getCurrentInstance, watch } from 'vue';
export default {
    name: "gljy-tree",
    emits: ["treeSelect", "resultQueryData"],
    props: {
        isToTree: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        // 是否自动查询
        isAutoInit: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        type: String,
        queryFunction: {
            type: [Function, Promise],
            default: (proxy) => {
                // 如果是预设的function, 那么获取后续的拼接参数, 从js中得到预设function
                if (proxy.type?.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return selectCustomFunction[presetFunctionObjKey]?.queryFunction;
                }
                return () => {
                };
            }
        },
        extendQueryWhere: {
            type: Object,
            default: (proxy) => {
                if (proxy.type?.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return selectCustomFunction[presetFunctionObjKey]?.extendQueryWhere;
                }
                return {}
            }
        },
        nodeKey: {
            type: String,
            default: "id"
        },
        fieldNames: {
            type: Object,
            default: (proxy) => {
                if (proxy.type?.indexOf("presetFunction") >= 0) {
                    const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
                    return selectCustomFunction[presetFunctionObjKey]?.fieldNames;
                }
                return { label: 'label', children: 'children', parentId: 'parentId', value: 'id' }
            }
        },
        searchPlaceholder: {
            type: String,
            default: "输入名称搜索"
        },
        // 设置默认展开层级
        spreadTreeLevel: {
            type: Number,
            default: () => {
                return 1;
            }
        }
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance();
        const treeRef = ref();
        const datas = reactive({
            searchTitle: "", // 搜索关键字
            options: [],
            currentNodeKey: undefined, // 当前选中节点
            i18nConfig
        })

        const key = computed(() => {
            return props.fieldNames.key;
        })

        watch(() => datas.searchTitle, (val) => {
            treeRef.value?.filter(val)
        })

        const methods = {
            queryTreeList() {
                props.queryFunction({}).then(response => {
                    if (props.isToTree) {
                        datas.options = [];
                        const data = proxy.handleTree(response.data, props.fieldNames.value, props.fieldNames.parentId, props.fieldNames.children);
                        const res = JSON.parse(JSON.stringify(response));
                        res.data = data;
                        context.emit("resultQueryData", res);
                        datas.options.push(...data);
                    } else {
                        context.emit("resultQueryData", response);
                        datas.options = response.data;
                    }
                });
            },
            filterNode(value, data) {
                if (!value) return true;
                return data[props.fieldNames.label]?.includes(value);
            },
            handleNodeClick(data) {
                // datas.currentNodeKey = data[props.nodeKey];
                context.emit("treeSelect", data)
            },
            setCurrentKey(key, shouldAutoExpandParent = true) {
                treeRef.value.setCurrentKey(key, shouldAutoExpandParent);
            }
        };

        onMounted(() => {
            if (props.isAutoInit) {
                methods.queryTreeList();
            }
        })

        return {
            treeRef,
            ...methods,
            ...toRefs(datas)
        }
    }
}
</script>

<style lang="less" scoped>
.search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>